import React from 'react';
import moment from 'moment';
import { StyledTextDiv } from '../../utils/reportUsage.styled';
import {
    getBrowserTimeZoneName,
    getDisplayDateTime,
} from 'src/utils/dateUtils';
import { sizes } from 'src/styles/Media.styled';
import { useTranslation } from 'react-i18next';

const PriceOverrideAndSignature = ({
    priceOverrideReason,
    signatureDetails,
    pricingNotes,
}) => {
    const {t} = useTranslation();
    return (
        <div
            style={{
                display:
                    window.innerWidth > sizes.mobileDevice ? 'flex' : 'block',
                justifyContent: 'space-between',
                paddingBottom: '10px',
            }}
        >
            {priceOverrideReason && (
                <div>
                    <StyledTextDiv
                        color="#202124"
                        fontSize="15px"
                        padding="10px 0 0"
                    >
                        {t('equity.priceOverride.overrideReason.title')}:
                    </StyledTextDiv>
                    <StyledTextDiv
                        color="#202124"
                        fontSize="14px"
                        fontFamily="AvenirNextWorld Regular"
                        textAlign="left"
                    >
                        {priceOverrideReason}
                    </StyledTextDiv>
                </div>
            )}
            {pricingNotes && (
                <div
                    style={{
                        width:
                            window.innerWidth >= sizes.mobileDevice &&
                            window.innerWidth <= sizes.mediumDevice
                                ? '48%'
                                : window.innerWidth > sizes.mobileDevice && '55%',
                    }}
                >
                    <StyledTextDiv
                        color="#202124"
                        fontSize="15px"
                        padding="10px 0 0"
                    >
                        {t('reportUsage.review.priceOverrideAndSignature.priceOverRideComments')}
                    </StyledTextDiv>
                    <StyledTextDiv className="report-usage-note-text-dt-mask"
                        color="#202124"
                        fontSize="14px"
                        fontFamily="AvenirNextWorld Regular"
                        textAlign="left"
                        width={window.innerWidth > sizes.mobileDevice && '65%'}
                    >
                        {pricingNotes}
                    </StyledTextDiv>
                </div>
            )}
            {signatureDetails && signatureDetails.dateOfSignature ? (
                <div>
                    <StyledTextDiv
                        color="#202124"
                        fontSize="15px"
                        padding="10px 0 0"
                    >
                       {t('reportUsage.review.priceOverrideAndSignature.signatureApplied')}
                    </StyledTextDiv>
                    <StyledTextDiv
                        color="#202124"
                        fontSize="14px"
                        fontFamily="AvenirNextWorld Regular"
                        textAlign="left"
                    >
                        {`${getDisplayDateTime(
                            signatureDetails.dateOfSignature
                        )} ${getBrowserTimeZoneName()}`}
                    </StyledTextDiv>
                </div>
            ) : <div></div>}
        </div>
    );
};

export default PriceOverrideAndSignature;
